import Glide from "@glidejs/glide";
import { Squares2X2Icon } from "@heroicons/react/24/outline";
import { Tab, Tabs } from "@mui/material";
import AlertModalMessage from "components/AlertModal/AlertModalMessage";
import ContactModal from "components/AlertModal/ContactModal";
import CommentListing from "components/CommentListing/CommentListing";
import FormItem from "components/FormItem/FormItem";
import LikeSaveBtns from "components/LikeSaveBtns";
import BookingLoader from "components/Loader/BookingLoader";
import DetailLoader from "components/Loader/DetailLoader";
import LoginModal from "components/LoginModal/LoginModal";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import NcInputNumberOne from "components/NcInputNumber/NcInputNumberOne";
import SocialMediaShare from "components/SocialMediaShare/SocialMediaShare";
import StartRating from "components/StartRating/StartRating";
import { AuthContext } from "context/appContext";
import { motion } from "framer-motion";
import { useAppDispatch, useAppSelector, useScrollToHash, useSingleInView } from "hooks/hooks";
import Cookies from "js-cookie";
import React, { FC, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet";
import { FaHome } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getOwnerById } from "redux/features/auth/authSlice";
import { createConversation } from "redux/features/conversation/conversationSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  addToFavoris,
  checkFavoriByClientId,
  deleteLocationFromFavoris,
  fetchCommentById,
  fetchLocationById,
  fetchPriceById,
  getFavorisByClient,
  getSimilarLocations,
  initStates,
} from "redux/features/locations/locationSlice";
import { fetchEvents } from "redux/features/Admin/Events/eventSlice";
import {
  checkReservation,
  fetchAvailableHours,
  fetchfullyDays,
  payReservation,
} from "redux/features/reservations/reservationSlice";
import { fetchUnavailableByLocation } from "redux/features/unavailable/unavailableSlice";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import CheckboxInput from "shared/Checkbox/CheckboxInput";
import NcImage from "shared/NcImage/NcImage";
import Select from "shared/Select/Select";
import TextDisplay from "utils/textAreaDisplay";
import MobileFooterSticky from "../(components)/MobileFooterSticky";
import DetailPagetLayout from "../Layout";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { EASING } from "../../../../utils/easingUtils";

const ListingStayDetailPage: FC<{}> = () => {
  let locationState = useAppSelector((state) => state.featureLocation.locationDetail);
  let fullyDaysState = useAppSelector((state) => state.featureReservation.fullyDays);
  let unavailableState = useAppSelector((state) => state.featureUnvailable.unavailables);
  let ownerState = useAppSelector((state) => state.auth.owner);
  let commentStates = useAppSelector((state) => state.featureLocation.locationDetail?.comments);
  let eventsState = useAppSelector((state) => state.featureEvent.events);

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const dispatch = useAppDispatch();
  const router = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const profilId = authContext?.user?.profil?.id;
  const [selectedDay, setSelectedDay] = useState<Date | null>(null);
  const [showAllComments, setShowAllComments] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [hours, setHours] = useState<number[]>([]);
  const [price, setPrice] = useState<any>(null);
  const [priceStartHour, setPriceStartHour] = useState<any>("");
  const [priceEndHour, setPriceEndHour] = useState<any>("");
  const [priceId, setPriceId] = useState<string>("");
  const [periode, setPeriode] = useState<number>(parseInt(locationState?.nbreHour?.toString(), 10) ?? 0);
  const [halfTotal, setHalfTotal] = useState<number>(0);
  const [tva, setTva] = useState<number>(0);
  const [extraTotal, setExtraTotal] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [reservation, setReservation] = useState<any>(null);
  const [services, setServices] = useState<number>(0);

  const [availableHoursState, setAvailableHoursState] = useState<{ start: number; durations: number[] }[]>([]);
  const [selectedStartHour, setSelectedStartHour] = useState<any | null>(null);
  const [selectedEndHour, setSelectedEndHour] = useState<any | null>(null);
  const [selectedDuration, setSelectedDuration] = useState<number | null>(null);

  const [selectedEvent, setSelectedEvent] = useState<string | null>("");
  const [maxDuration, setMaxDuration] = useState<number>(0);
  const [Submit, setSubmit] = useState<boolean>(false);
  const [allDescs, setAllDesc] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModalExistReservation, setShowModalExistReservation] = useState(false);
  const [showSocialMediaShare, setShowSocialMediaShare] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [visitorRange, setVisitorRange] = useState<string | undefined>(undefined);
  const [isCleaningCosts, setIsCleaningCosts] = useState(false);
  const states = useAppSelector((state) => state.featureLocation);
  const [availableDays, setAvailableDays] = useState<string[]>(locationState?.availableDays || []);

  const acceptedCookies = Cookies.getJSON("eventtobee");
  const [cookies, setCookie] = useCookies(["visitedLocations"]);
  const [checkedExtra, setCheckedExtra] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(locationState?.minPriceType);
  const [contact, setContact] = useState(false);
  const lat = 48.8584;
  const lng = 2.2945;

  const { ref: commentsRef, inView: commentsInView } = useSingleInView();
  const { ref: ownerRef, inView: ownerInView } = useSingleInView();
  const formItemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, ease: EASING.easeOut },
    },
  };

  useEffect(() => {
    if (locationState?.prices && value) {
      const filteredDays = Array.from(
        new Set(
          locationState.prices
            .filter((price: any) => price.type === value && price.enable)
            .map((price: any) => price.day)
        )
      );
      setAvailableDays(filteredDays);
    } else {
      setAvailableDays(locationState?.availableDays || []);
    }
  }, [value, locationState?.prices, locationState?.availableDays]);

  const [location_minPrice, setLocation_MinPrice] = useState<number | null>(null);

  useEffect(() => {
    if (!locationState?.prices) {
      console.log("❌ No locationState.prices available");
      return;
    }

    const prices_list = locationState.prices;
    let minPrice: number | null = null;

    console.log("🔍 Calculating min price for:", value);
    console.log("📊 Available prices:", prices_list);

    // Debug: montrer tous les types de prix disponibles
    const allTypes = prices_list.map((price: any) => price.type);
    console.log("🏷️ All price types found:", allTypes);
    console.log("🏷️ Unique price types:", Array.from(new Set(allTypes)));

    if (value === "journée complète") {
      const journeePrices = prices_list
        .filter((price: any) => price.type === "journée complète")
        .map((price) => price.price)
        .filter((price) => price > 0); // Filtrer les prix à 0€
      minPrice = journeePrices.length > 0 ? Math.min(...journeePrices) : null;
      console.log("💰 Journée complète prices:", journeePrices, "Min:", minPrice);
    } else if (value === "heure") {
      const heurePrices = prices_list
        .filter((price: any) => price.type === "heure")
        .map((price) => price.price)
        .filter((price) => price > 0); // Filtrer les prix à 0€
      minPrice = heurePrices.length > 0 ? Math.min(...heurePrices) : null;
      console.log("💰 Heure prices:", heurePrices, "Min:", minPrice);
    } else if (value === "soirée") {
      const soireePrices = prices_list
        .filter((price: any) => price.type === "soirée")
        .map((price) => price.price)
        .filter((price) => price > 0); // Filtrer les prix à 0€
      minPrice = soireePrices.length > 0 ? Math.min(...soireePrices) : null;
      console.log("💰 Soirée prices:", soireePrices, "Min:", minPrice);
    } else if (value === "demi-journée") {
      const demiJourneePrices = prices_list
        .filter(
          (price: any) =>
            price.type === "demi-journée" ||
            price.type === "demi-journée matin" ||
            price.type === "demi-journée après-midi"
        )
        .map((price) => price.price)
        .filter((price) => price > 0); // Filtrer les prix à 0€

      minPrice = demiJourneePrices.length > 0 ? Math.min(...demiJourneePrices) : null;
      console.log(
        "💰 Demi-journée all prices:",
        prices_list.filter((p: any) => p.type === "demi-journée").map((p: any) => p.price)
      );
      console.log("💰 Demi-journée filtered prices (> 0):", demiJourneePrices);
      console.log("💰 Demi-journée min price:", minPrice);
    }

    console.log("📈 Final min price set:", minPrice);
    setLocation_MinPrice(minPrice);
  }, [value, locationState.prices]);

  const isLiked = useAppSelector((state) => {
    const likedLocation = state?.featureLocation.likedLocation || [];
    const locationId = id;
    if (Array.isArray(likedLocation) && likedLocation.length > 0 && locationId) {
      const foundItem = likedLocation.find((item: any) => item.locationId === locationId);
      return !!foundItem;
    }
    return true;
  });

  useEffect(() => {
    const parsedValue = parseInt(locationState?.nbreHour?.toString(), 10);
    if (!isNaN(parsedValue)) {
      setPeriode(parsedValue);
    }
  }, [locationState?.nbreHour]);

  const [formData, setFormData] = useState({
    selectedDate: selectedDay,
    reservation_unit: value,
    startHour: selectedStartHour ? String(selectedStartHour + ":00") : priceStartHour,
    endHour: selectedStartHour ? String(Number(selectedStartHour + periode) + ":00") : priceEndHour,
    validation: false,
    visitor: locationState.visitor,
    locationId: locationState?.id,
    ownerId: locationState?.Client?.id,
    price: total,
    tva: tva,
    halfTotal: halfTotal,
    extra: extraTotal,
    service: services,
    menagementPrice: isCleaningCosts ? locationState.cleaning_costs : 0,
  });

  const googleMapsURL = `https://www.google.com/maps/embed/v1/place?key=${
    process.env.REACT_APP_MAPS_API_KEY
  }&q=${Number(lat)},${Number(lng)}`;

  useEffect(() => {
    dispatch(initStates());
    if (id && profilId) {
      dispatch(checkFavoriByClientId({ locationId: id, clientId: profilId }));
    }
  }, [id, profilId, dispatch]);

  useEffect(() => {
    if (profilId) {
      dispatch(getFavorisByClient({ clientId: profilId }));
    }
  }, [profilId]);

  // Charger la liste des événements pour le mappage
  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  useEffect(() => {
    if (acceptedCookies === "accepted") {
      const visitedLocations = cookies.visitedLocations || [];

      const isVisited = visitedLocations.includes(id);

      if (!isVisited) {
        const updatedVisitedLocations = [...visitedLocations, id];
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 30);
        setCookie("visitedLocations", updatedVisitedLocations, { path: "/", expires: expirationDate });
      }
    }
  }, [id, cookies.visitedLocations, setCookie]);

  useEffect(() => {
    if (id && locationState?.CategoryLocation?.id) {
      dispatch(getSimilarLocations({ locationId: parseInt(id), categoryId: locationState.CategoryLocation.id }));
    }
  }, [id, locationState?.CategoryLocation?.id, dispatch]);

  const glideRef = useRef(null);
  const relatedLocations = useAppSelector((state) => state.featureLocation.similarLocations);

  useEffect(() => {
    if (relatedLocations && glideRef.current) {
      const glide = new Glide(glideRef.current, {
        type: "carousel",
        perView: 4,
        gap: 20,
        autoplay: 1500,
      });

      glide?.mount();
      return () => glide?.destroy();
    }
  }, [relatedLocations]);

  useEffect(() => {
    // Only set initial value if no value is currently set (avoid overriding user selection)
    if (!value && locationState?.minPriceType) {
      console.log("🔧 Setting initial value to:", locationState?.minPriceType);
      setValue(locationState?.minPriceType);
    }
  }, [locationState?.minPriceType]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (id && id !== "undefined") {
          const res = await dispatch(fetchLocationById(id));
          if (res.payload.validation !== "approuvé" && profilId !== res.payload.userId) {
            navigate("/espace-evenementiel");
            return;
          } else {
            await dispatch(fetchUnavailableByLocation(id));
          }
        }
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    fetchData();
    return () => {
      setReservation(null);
    };
  }, [id, profilId, dispatch, navigate]);

  // Refetch unavailable dates when tab becomes visible (after user might have blocked dates in another tab)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && id && id !== "undefined") {
        dispatch(fetchUnavailableByLocation(id));
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (locationState?.minStartHour && locationState?.maxEndHour) {
      const startHour = parseInt(locationState.minStartHour);
      const endHour = parseInt(locationState.maxEndHour);
      const updatedHour = generateHoursArray(startHour, endHour);
      setHours(updatedHour);
    }
  }, [locationState?.minStartHour, locationState?.maxEndHour]);

  useEffect(() => {
    const total = checkedExtra.reduce(
      (acc, checkedItem) => (checkedItem.isChecked ? acc + checkedItem.price * checkedItem.qte : acc),
      0
    );
    setExtraTotal(total);
  }, [checkedExtra]);

  useEffect(() => {
    if (periode) {
      handleTotalChange(periode);
    }
  }, [extraTotal, periode, price, selectedEvent, selectedDay]);

  useEffect(() => {
    setFormData({
      selectedDate: selectedDay,
      reservation_unit: value,
      startHour: value === "heure" ? (selectedStartHour ? `${selectedStartHour}:00` : "") : priceStartHour,

      endHour:
        value === "heure" ? (selectedStartHour ? `${Number(selectedStartHour) + periode}:00` : "") : priceEndHour,

      validation: false,
      visitor: locationState.visitor,
      locationId: locationState?.id,
      ownerId: locationState?.userId,
      price: total,
      halfTotal: halfTotal,
      tva: tva,
      extra: extraTotal,
      service: services,
      menagementPrice: isCleaningCosts ? locationState.cleaning_costs : 0,
    });
  }, [total, selectedDay, selectedStartHour]);

  const handleClickLike = useCallback(async () => {
    if (!profilId) {
      setShowLoginModal(true);
      return;
    }
    if (id && states.likedLocation) {
      if (isLiked) {
        await dispatch(addToFavoris({ locationId: id, clientId: profilId }));
      } else {
        await dispatch(deleteLocationFromFavoris({ locationId: id, clientId: profilId }));
      }
      await dispatch(getFavorisByClient({ clientId: profilId }));
    }
  }, [profilId, id, isLiked, states.likedLocation, dispatch]);

  const generateHoursArray = (startHour: any, endHour: any) => {
    const updatedHour = [];
    for (let i = startHour; i <= endHour; i++) {
      updatedHour.push(i);
    }
    return updatedHour;
  };

  const handleShareButtonClick = () => {
    setShowSocialMediaShare(!showSocialMediaShare);
  };

  const handleChangeData = (itemIdentifier: any, value: any) => {
    setCheckedExtra((prevCheckedExtra) => {
      const updatedArray = [...prevCheckedExtra];
      const targetIndex = updatedArray.findIndex(
        (x) =>
          x.designation === itemIdentifier.designation &&
          x.price === itemIdentifier.price &&
          x.priceId === itemIdentifier.priceId
      );

      if (targetIndex !== -1) {
        updatedArray[targetIndex] = {
          ...updatedArray[targetIndex],
          qte: value,
        };
      }

      return updatedArray;
    });
  };

  const [selectedPriceId, setSelectedPriceId] = useState("");
  const handleChangePrice = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    let res;
    const selectedPriceId = event.target.value;
    setSelectedPriceId(selectedPriceId);
    setPriceId(selectedPriceId);

    res = (await dispatch(fetchPriceById(event.target.value))) as {
      payload: {
        price: number;
        priceId: string;
        min: string;
        max: string;
        type: string;
        startHour: string;
        endHour: string;
      };
    };

    if (res.payload) {
      setPrice(res.payload.price);
      setPriceStartHour(res.payload.startHour);
      setPriceEndHour(res.payload.endHour);
      setPriceId(res.payload.priceId);
      setVisitorRange(`${res.payload.min} - ${res.payload.max}`);

      // Trigger price calculation if hour range is already selected for demi-journée/soirée
      if (selectedHourRange && (value === "demi-journée" || value === "soirée")) {
        console.log("🚀 Triggering price calculation after visitor selection");
        setTimeout(() => handleTotalChange(1), 100); // Small delay to ensure state is updated
      }
    }
  };

  const handleExtraCheckboxChange = (item: any, isChecked: boolean) => {
    if (!item) return;

    setCheckedExtra((prevCheckedExtra) => {
      const index = prevCheckedExtra.findIndex(
        (x) => x.designation === item.designation && x.price === item.price && x.priceId === item.priceId
      );

      if (index === -1 && isChecked) {
        return [...prevCheckedExtra, { ...item, isChecked: true, qte: 1 }];
      }

      if (index !== -1) {
        const updated = [...prevCheckedExtra];
        if (isChecked) {
          updated[index] = { ...updated[index], isChecked: true };
        } else {
          updated.splice(index, 1); // supprime l’item décoché
        }
        return updated;
      }

      return prevCheckedExtra;
    });
  };
  const [showLastMinuteWarning, setShowLastMinuteWarning] = useState(false);
  const [isConfirmedLastMinute, setIsConfirmedLastMinute] = useState(false);
  const handleSubmit = async () => {
    setIsLoadingSubmit(true);

    if (!profilId || authContext.user?.role !== "client") {
      if (setShowLoginModal) {
        setShowLoginModal(true);
        setIsLoadingSubmit(false);
        return;
      }
    }

    const selectedDate = formData.selectedDate;
    if (selectedDate) {
      const now = new Date();
      const diff = selectedDate && selectedDate?.getTime() - now.getTime();
      const isInPast = selectedDate && diff < 0;
      const isLessThan48h = selectedDate && diff < 48 * 60 * 60 * 1000 && diff > 0;
      if (isInPast) {
        // Already handled by button disabling, but you can double-protect here
        setIsLoadingSubmit(false);
        return;
      }

      if (isLessThan48h && !isConfirmedLastMinute) {
        setShowLastMinuteWarning(true);
        setIsLoadingSubmit(false);
        return;
      }
    }

    // Proceed with normal flow
    const check = await dispatch(checkReservation(formData));

    if (check.payload.error) {
      setShowModalExistReservation(true);
      setIsLoadingSubmit(false);
    } else {
      if (!id || id === "undefined") {
        console.error("Error: Location ID is undefined");
        setIsLoadingSubmit(false);
        return;
      }

      const res = await dispatch(
        payReservation({
          quantity: periode,
          priceId,
          location: id,
          extra: checkedExtra,
          reservation: formData,
          visitor: visitorRange,
          commission: locationState?.commission,
        })
      );

      if (res.payload && typeof res.payload === "string" && res.payload.startsWith("http")) {
        window.location.href = res.payload;
      } else {
        console.error("Error: Invalid payment URL returned:", res.payload);
        setIsLoadingSubmit(false);
      }
    }
  };

  const handleContact = async () => {
    if (!profilId || authContext.user?.role !== "client") {
      if (setShowLoginModal) {
        setShowLoginModal(true);
        setIsLoadingSubmit(false);
        return;
      }
    } else {
      setContact(true);
    }
  };
  useEffect(() => {
    if (selectedStartHour === null) {
      setMaxDuration(parseInt(locationState?.nbreHour || "1"));
      return;
    }

    // 1) On trouve l’objet slot pour l’heure choisie
    const slot = availableHoursState.find((s) => s.start === selectedStartHour);
    if (!slot) {
      // si aucun créneau, on met le minimum
      setMaxDuration(parseInt(locationState?.nbreHour || "1"));
      return;
    }

    // 2) La durée maximale ‘brute’ est la dernière entrée de slot.durations
    const rawMax = slot.durations[slot.durations.length - 1];
    // 3) On s’assure qu’on ne soit pas en dessous du min
    const minH = parseInt(locationState?.nbreHour || "1");
    setMaxDuration(Math.max(rawMax, minH));
  }, [selectedStartHour, availableHoursState, locationState?.nbreHour]);
  const handleSelectedDayChange = async (day: Date) => {
    setSelectedDay(day);
    setSelectedStartHour(null);
    setMaxDuration(0);
    if (value === "heure") {
      setPeriode(parseInt(locationState?.nbreHour));
    } else {
      setPeriode(1);
    }

    if (day) {
      setSubmit(true);

      // Formater la date au format YYYY-MM-DD pour l'API
      const formatDateForAPI = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const dayOfMonth = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${dayOfMonth}`;
      };

      const formattedDate = formatDateForAPI(day);

      (async () => {
        try {
          // On dispatche le thunk et on "unwrap" pour récupérer directement le payload
          const actionResult = await dispatch(
            fetchAvailableHours({ id, selectedDay: formattedDate, type: value })
          );
          const slots = unwrapResult(actionResult);

          // slots est un HourSlot[] si tout s'est bien passé
          setAvailableHoursState(Array.isArray(slots) ? slots : []);
        } catch (err) {
          console.error("Impossible de charger les créneaux :", err);
          setAvailableHoursState([]);
        }
      })();

      setSubmit(false);
    }
  };

  useEffect(() => {
    setSelectedStartHour(null);
    setSelectedEndHour(null);
    setPriceEndHour(null);
    setPriceStartHour(null);
    setSelectedHourRange("");
    setSelectedEvent("");
    setTotal(0);
    setServices(0);
    setHalfTotal(0);
  }, [selectedDay]);

  useEffect(() => {
    setAvailableHoursState([]);
    setSelectedDay(null);
    setSelectedStartHour(null);
    setSelectedEndHour(null);
    setTotal(0);
    setServices(0);
    setHalfTotal(0);
  }, [value]);

  const handleAvailibility = async () => {
    dispatch(fetchfullyDays({ id: id, type: value }));
  };
  const handleTotalChange = (hour: number) => {
    console.log("🔧 handleTotalChange appelé avec:", { hour, value, price, locationState: !!locationState });

    let cleaning_costs;
    let isValid = false;

    if (selectedEvent) {
      isValid = locationState?.cleaning_costs_events?.some((event: any) => event.trim() === selectedEvent.trim());
      setIsCleaningCosts(isValid);
    }

    if (isValid) {
      cleaning_costs = locationState.cleaning_costs || 0;
    } else {
      cleaning_costs = 0;
    }

    if (hour !== null && locationState !== undefined) {
      // Si price n'est pas défini, utiliser le prix minimum du type sélectionné
      let effectivePrice = price;

      if (!effectivePrice && value) {
        const prices_list = locationState.prices;
        let minPrice: number | null = null;

        console.log("🔍 Recherche prix pour type:", value, "dans:", prices_list);

        if (value === "demi-journée") {
          // Pour demi-journée, chercher le prix spécifique à la plage horaire sélectionnée
          if (selectedHourRange && selectedHourRange.includes("-")) {
            const [startHour, endHour] = selectedHourRange.split("-");
            console.log("🕐 Recherche prix pour plage:", startHour, "-", endHour);

            // Chercher un prix qui correspond exactement à cette plage horaire
            const exactPrice = prices_list.find((priceItem: any) => {
              const matchesType =
                priceItem.type === "demi-journée" ||
                priceItem.type === "demi-journée matin" ||
                priceItem.type === "demi-journée après-midi";
              const matchesHour =
                priceItem.startHour === startHour + ":00" && priceItem.endHour === endHour + ":00";
              return matchesType && matchesHour && priceItem.price > 0;
            });

            if (exactPrice) {
              minPrice = exactPrice.price;
              console.log("✅ Prix exact trouvé pour", startHour + "-" + endHour + ":", exactPrice.price + "€");
            } else {
              // Fallback: utiliser le prix minimum si aucun prix exact trouvé
              const demiJourneePrices = prices_list
                .filter(
                  (priceItem: any) =>
                    priceItem.type === "demi-journée" ||
                    priceItem.type === "demi-journée matin" ||
                    priceItem.type === "demi-journée après-midi"
                )
                .map((priceItem) => priceItem.price)
                .filter((price) => price > 0);
              minPrice = demiJourneePrices.length > 0 ? Math.min(...demiJourneePrices) : null;
              console.log("⚠️ Aucun prix exact, utilisation du minimum:", minPrice + "€");
            }
          } else {
            // Si pas de plage sélectionnée, utiliser le prix minimum
            const demiJourneePrices = prices_list
              .filter(
                (priceItem: any) =>
                  priceItem.type === "demi-journée" ||
                  priceItem.type === "demi-journée matin" ||
                  priceItem.type === "demi-journée après-midi"
              )
              .map((priceItem) => priceItem.price)
              .filter((price) => price > 0);
            minPrice = demiJourneePrices.length > 0 ? Math.min(...demiJourneePrices) : null;
            console.log("💰 Prix demi-journée (pas de plage sélectionnée):", minPrice + "€");
          }
        } else if (value === "soirée") {
          const soireePrices = prices_list
            .filter((priceItem: any) => priceItem.type === "soirée")
            .map((priceItem) => priceItem.price)
            .filter((price) => price > 0); // Filtrer les prix à 0€
          minPrice = soireePrices.length > 0 ? Math.min(...soireePrices) : null;
        } else if (value === "heure") {
          const heurePrices = prices_list
            .filter((priceItem: any) => priceItem.type === "heure")
            .map((priceItem) => priceItem.price)
            .filter((price) => price > 0); // Filtrer les prix à 0€
          minPrice = heurePrices.length > 0 ? Math.min(...heurePrices) : null;
        } else if (value === "journée complète") {
          const journeePrices = prices_list
            .filter((priceItem: any) => priceItem.type === "journée complète")
            .map((priceItem) => priceItem.price)
            .filter((price) => price > 0); // Filtrer les prix à 0€
          minPrice = journeePrices.length > 0 ? Math.min(...journeePrices) : null;
        }

        effectivePrice = minPrice;
      }

      console.log("💵 Prix effectif utilisé:", effectivePrice);

      if (effectivePrice) {
        const firstPrice = hour * Number(effectivePrice);

        console.log("🧮 Calcul prix:", { hour, effectivePrice, firstPrice, extraTotal, cleaning_costs });

        setHalfTotal(firstPrice);
        const calculatedServices = Number(
          ((locationState?.commission / 100) * (firstPrice + extraTotal + (isValid ? cleaning_costs : 0))).toFixed(
            2
          )
        );
        const calculatedTva = Number((0.2 * calculatedServices).toFixed(2));
        const calculatedTotal = Number(
          (calculatedServices + firstPrice + extraTotal + (isValid ? cleaning_costs : 0)).toFixed(2)
        );
        setServices(calculatedServices);
        setTva(calculatedTva);
        setTotal(calculatedTotal);

        console.log("✅ Prix calculé - Total:", calculatedTotal);
      } else {
        console.log("❌ Aucun prix effectif trouvé - reset à 0");
        setServices(0);
        setTotal(0);
        setHalfTotal(0);
      }
    } else {
      console.log("❌ Conditions non remplies pour calcul prix");
      setServices(0);
      setTotal(0);
      setHalfTotal(0);
    }
  };

  useEffect(() => {
    if (selectedDay) {
      setSelectedPriceId("");
      setPrice(null);
      setPriceId("");
      setVisitorRange(undefined);
      setAvailableHoursState([]);
      // On réinitialise le choix de départ et de durée
      setSelectedStartHour(null);
      setSelectedDuration(null);
    }
  }, [selectedDay]);

  const handleStartHourChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedHour = parseInt(event.target.value);
    setSelectedStartHour(selectedHour);

    setMaxDuration(parseInt(locationState?.nbreHour || "1"));
    setPeriode(parseInt(locationState?.nbreHour || "1"));
    const { maxConsecutiveHours } = findMaxConsecutiveHours(
      availableHoursState,
      selectedStartHour!,
      parseInt(locationState.nbreHour)
    );
    setMaxDuration(maxConsecutiveHours);
    if (maxConsecutiveHours + 1 < parseInt(locationState?.nbreHour)) {
      setShowModal(true);
    }

    handleTotalChange(parseInt(locationState?.nbreHour));
  };

  const [selectedHourRange, setSelectedHourRange] = useState<string>("");
  const handleStartHourChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedHourRange = event.target.value;
    console.log("🕐 Hour range selected:", selectedHourRange);
    setSelectedHourRange(selectedHourRange);
    if (typeof selectedHourRange === "string" && selectedHourRange.includes("-")) {
      const formatTime = (time: string) => {
        const hour = time.padStart(2, "0");
        const minute = "00";
        return `${hour}:${minute}`;
      };

      const [startHour, endHour] = selectedHourRange.split("-");
      const formattedStartHour = formatTime(startHour);
      const formattedEndHour = formatTime(endHour);

      setSelectedStartHour(formattedStartHour);
      setSelectedEndHour(formattedEndHour);

      // Trigger price calculation if visitor range is already selected
      if (visitorRange && (value === "demi-journée" || value === "soirée")) {
        console.log("🚀 Triggering price calculation after hour range selection");
        handleTotalChange(1);
      }
    } else {
      setSelectedStartHour(null);
      setSelectedEndHour(null);
    }
  };

  const handleEventTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const evnt = event.target.value;
    setSelectedEvent(evnt);
  };

  useEffect(() => {
    if (selectedEvent) {
      handleTotalChange(parseInt(locationState?.nbreHour || "0"));
    }
  }, [selectedEvent]);

  // Déclencher automatiquement le calcul du prix pour demi-journée et soirée
  // Fetch available hours when value or selectedDay changes
  useEffect(() => {
    if (selectedDay && value && id) {
      const formatDateForAPI = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const dayOfMonth = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${dayOfMonth}`;
      };

      const formattedDate = formatDateForAPI(selectedDay);
      console.log("🔍 Fetching available hours for:", { value, formattedDate });

      (async () => {
        try {
          const actionResult = await dispatch(
            fetchAvailableHours({ id, selectedDay: formattedDate, type: value })
          );
          const slots = unwrapResult(actionResult);
          console.log("✅ Available hours fetched:", slots);
          setAvailableHoursState(Array.isArray(slots) ? slots : []);
        } catch (err) {
          console.error("❌ Impossible de charger les créneaux :", err);
          setAvailableHoursState([]);
        }
      })();
    }
  }, [value, selectedDay, id, dispatch]);

  useEffect(() => {
    console.log("🔍 Debug demi-journée/soirée:", {
      value,
      selectedHourRange,
      visitorRange,
      total,
      price,
      priceId,
      condition: (value === "demi-journée" || value === "soirée") && selectedHourRange && visitorRange,
    });

    if ((value === "demi-journée" || value === "soirée") && selectedHourRange && visitorRange && !total) {
      console.log("🚀 Déclenchement handleTotalChange pour demi-journée/soirée");
      // Utiliser période par défaut = 1 pour demi-journée et soirée
      handleTotalChange(1);
    }
  }, [value, selectedHourRange, visitorRange, total, price, priceId]);

  useEffect(() => {}, [selectedDay]);

  const findMaxConsecutiveHours = (
    availableSlots: { start: number; durations: number[] }[],
    selectedHour: number,
    minHours: number
  ) => {
    // 1) Chercher l’objet dont start === selectedHour
    const slot = availableSlots.find((s) => s.start === selectedHour);

    // 2) si on ne trouve pas, on retourne simplement le minHours
    if (!slot) {
      return { maxConsecutiveHours: minHours };
    }

    // 3) dans slot.durations, la dernière entrée est la durée maximale
    //    (on suppose que durations est trié en ordre croissant, ex. [4,5,6])
    const lastIndex = slot.durations.length - 1;
    let maxConsecutive = slot.durations[lastIndex];

    // 4) on s’assure que le résultat ne soit jamais inférieur à minHours
    maxConsecutive = Math.max(maxConsecutive, minHours);

    return { maxConsecutiveHours: maxConsecutive };
  };

  const handleChangeDuration = (duration: number) => {
    setPeriode(duration);
  };

  const handleOpenModalImageGallery = () => {
    router(`${location.pathname}?gallery=images`);
  };

  const handleConversation = async () => {
    await dispatch(createConversation(parseInt(locationState?.Client?.userId)));
    navigate(`/client/messages`);
  };

  const handleChange = (event: any, newValue: any) => {
    console.log("🎯 Tab changed to:", newValue);
    setValue(newValue);
    // Reset form fields when switching tabs
    setSelectedHourRange("");
    setVisitorRange(undefined);
    setTotal(0);
    setPrice(null);
    setPriceId("");
    setSelectedPriceId("");
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex items-center justify-between">
          <Badge
            name={
              <div className="flex items-center">
                <i className="text-sm las la-share-alt"></i>
                <span className="ml-1">{locationState && locationState?.CategoryLocation?.designation}</span>
              </div>
            }
          />
          <Badge
            name={
              <div className="flex items-center">
                <i className="las la-map-marker"></i>
                <span className="ml-1">{locationState?.city}</span>
              </div>
            }
            color="yellow"
          />
          <LikeSaveBtns onClick={handleClickLike} isFavorited={!isLiked} share={handleShareButtonClick} />
        </div>

        <AlertModalMessage
          open={showModal}
          handleClose={() => setShowModal(false)}
          message={`Veuillez noter que la réservation nécessite au moins 2 heures.`}
          alertText="Important"
        />
        <AlertModalMessage
          open={showModalExistReservation}
          handleClose={() => setShowModalExistReservation(false)}
          message={`Il semble qu'il y ait déjà une réservation pour cette période.`}
          alertText="Oups !"
        />
        {/* 2 */}
        <h2 className="text-2xl font-semibold sm:text-3xl lg:text-4xl">{locationState?.title}</h2>

        {/* 3 */}
        <div className="flex items-center space-x-4">
          <StartRating point={locationState?.averageLikes} reviewCount={locationState?.commentCount} />
          <span>·</span>
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1">
              {" "}
              {/* {locationState?.address}, {locationState?.address2} */}
              {locationState?.city}, {locationState?.codePostale}
              {location.search !== "" && (
                <>
                  , {locationState?.address} {locationState?.address2}
                </>
              )}
            </span>
          </span>
        </div>

        {/* 4 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <a href={`/owners/${locationState?.Client?.id}`}>
              <Avatar
                hasChecked
                sizeClass="h-10 w-10"
                radius="rounded-full"
                imgUrl={
                  locationState?.Client?.client_url
                    ? process.env.REACT_APP_CLOUD_FRONT + locationState?.Client?.client_url
                    : ""
                }
              />
            </a>
            <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
              Publié par :{" "}
              <span className="font-medium text-neutral-900 dark:text-neutral-200">
                <span>{locationState?.Client?.name}</span>
              </span>
            </span>
          </div>
        </div>

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        <div className="flex flex-col space-y-4 text-sm text-neutral-700 dark:text-neutral-300 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:space-x-8 xl:flex-row xl:items-center xl:justify-start xl:space-x-12">
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-expand"></i>
            <span className="">
              <span className="">Superficie</span> {locationState?.surface} m²
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-user"></i>
            <span className="">
              <span className="">Capacité d'accueil</span> {locationState?.visitor}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-clock"></i>
            <span className="">
              {String(locationState?.minStartHour).padStart(2, "0")}:00 -{" "}
              {String(locationState?.maxEndHour).padStart(2, "0")}:00
            </span>
          </div>
          {locationState?.handicap !== false && (
            <div className="flex items-center space-x-3">
              <i className="text-2xl lab la-accessible-icon"></i>
              <span className="">Accessible </span>
            </div>
          )}
        </div>
        <div className="flex flex-col space-y-4 text-sm text-neutral-700 dark:text-neutral-300 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:space-x-8 xl:flex-row xl:items-center xl:justify-start xl:space-x-12">
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-toilet"></i>
            <span className="">WC {locationState?.wc}</span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-parking"></i>
            <span className="">
              Parking {locationState?.parking} <span className="hidden sm:inline-block"></span>
            </span>
          </div>
          {locationState?.water && (
            <div className="flex items-center space-x-3">
              <i className="text-2xl las la-shower"></i>
              <span className="">Point d'eau </span>
            </div>
          )}
          {locationState?.light && (
            <div className="flex items-center space-x-3">
              <i className="text-2xl las la-lightbulb"></i>
              <span className="">Eclairage nocturne </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    const desc = locationState?.description.slice(0, 675);
    const allDesc = locationState?.description;
    const handleClickVoirPlus = () => {
      setAllDesc(false);
    };
    const handleClickVoirMoins = () => {
      setAllDesc(true);
    };

    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Description</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>

        <div className="flex flex-wrap items-center gap-2">
          {locationState.atmosphere.length > 0 &&
            locationState?.atmosphere.map((item: any, index: number) => (
              <div key={index} className="flex items-center space-x-1">
                <div className=""></div>
                <Badge href="##" color="purple" name={item} />
              </div>
            ))}
        </div>

        <div className="text-neutral-6000 dark:text-neutral-300">
          <TextDisplay text={allDescs ? desc : locationState?.description} />
          {/* <span>{allDescs ? desc : locationState?.description}</span> */}
          {locationState?.description.length >= 675 && allDescs && (
            <span className="text-sm text-blue-500 cursor-pointer hover:underline" onClick={handleClickVoirPlus}>
              {" "}
              Voir plus
            </span>
          )}

          {allDesc && allDescs === false && (
            <span className="text-sm text-blue-500 cursor-pointer hover:underline" onClick={handleClickVoirMoins}>
              {" "}
              Voir moins
            </span>
          )}
        </div>
      </div>
    );
  };

  const RenderSection = ({
    title,
    items,
    iconClass,
    renderItem,
  }: {
    title: string;
    items: any[];
    iconClass: string;
    renderItem: (item: any) => React.ReactNode;
  }) => (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{title}</h2>
      </div>
      <div className="grid grid-cols-1 gap-6 text-sm xl:grid-cols-3 text-neutral-700 dark:text-neutral-300">
        {items?.map((item: any, index: number) => (
          <div key={index} className="flex items-center space-x-3">
            <i className={`text-2xl ${iconClass}`}></i>
            <span>{renderItem(item)}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const RenderSection2 = ({
    title,
    items,
    iconClass,
    renderItem,
  }: {
    title: string;
    items: any[];
    iconClass: string;
    renderItem: (item: any) => React.ReactNode;
  }) => (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{title}</h2>
      </div>
      <div className="grid grid-rows-1 gap-6 text-sm xl:grid-rows-3 text-neutral-700 dark:text-neutral-300">
        {items?.map((item: any, index: number) => (
          <div key={index} className="flex items-center space-x-3">
            <i className={`text-2xl ${iconClass}`}></i>
            <span>{renderItem(item)}</span>
          </div>
        ))}
      </div>
    </div>
  );

  // Section 3 - Equipment
  const renderSection3 = () => (
    <RenderSection
      title="Équipements Disponibles"
      items={locationState?.equipments}
      iconClass="las la-check"
      renderItem={(item: any) => item?.equipment}
    />
  );

  // Fonction pour mapper les événements ID/nom vers les noms complets
  const mapEventToName = (eventItem: any): string => {
    if (!eventItem) return "";

    // Si c'est déjà un nom complet d'événement (pas un ID numérique)
    if (isNaN(eventItem) && typeof eventItem === "string") {
      return eventItem;
    }

    // Si c'est un ID numérique, chercher le nom dans eventsState
    if (eventsState && eventsState.length > 0) {
      const event = eventsState.find((e: any) => e.id === parseInt(eventItem) || e.id === eventItem.toString());
      if (event && (event as any).designation) {
        return (event as any).designation;
      }
    }

    // Fallback: retourner l'item tel quel
    return eventItem.toString();
  };

  // Events Section
  const renderEventsSection = () => (
    <RenderSection
      title="Événements"
      items={locationState?.events}
      iconClass="las la-handshake"
      renderItem={(item: any) => mapEventToName(item)}
    />
  );

  // Playground Section
  const renderPlayGroundsSection = () => (
    <RenderSection
      title="Aire de jeux"
      items={locationState?.playground}
      iconClass="las la-dice"
      renderItem={(item: any) => item}
    />
  );

  // Condition Section
  const renderSection9 = () => (
    <RenderSection2
      title="Les règles de cet espace"
      items={locationState.conditions}
      iconClass="las la-exclamation-triangle"
      renderItem={(item: any) => item?.designation}
    />
  );

  const renderSection10 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Extra équipements</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <div className="">
            {locationState?.extras &&
              !reservation &&
              locationState?.extras?.map((item: any, index: number) => (
                <div key={index} className="flex items-center justify-between mt-3">
                  {String(locationState.Client.id) !== String(authContext.user?.profil?.id) ? (
                    <CheckboxInput
                      name={item.designation}
                      key={item.designation}
                      label={`${
                        item.price !== 0 ? `${item.designation}: ${item.price} €` : `${item.designation}: Gratuit`
                      }`}
                      onChange={(e) => handleExtraCheckboxChange(item, e.checked)}
                      checked={
                        item &&
                        checkedExtra.some(
                          (checkedItem) =>
                            checkedItem.designation === item.designation && checkedItem.price === item.price
                        )
                      }
                    />
                  ) : (
                    <div key={item.designation} className="flex items-center space-x-3">
                      <i className="text-2xl las la-check"></i>
                      <span className="">
                        {item.price !== 0
                          ? `${item.designation}: ${item.price} €`
                          : `${item.designation}: Gratuit`}
                      </span>
                    </div>
                  )}

                  {String(locationState.Client.id) !== String(authContext.user?.profil?.id) && (
                    <div className="">
                      <NcInputNumberOne
                        onChange={(value) => handleChangeData(item, value)} // ← Changement ici : passer 'item' au lieu de 'index'
                        defaultValue={
                          // Récupérer la quantité actuelle depuis checkedExtra
                          checkedExtra.find(
                            (checkedItem) =>
                              checkedItem.designation === item.designation &&
                              checkedItem.price === item.price &&
                              checkedItem.priceId === item.priceId
                          )?.qte || 1
                        }
                        min={1}
                        max={item.quantity}
                        disabled={
                          !checkedExtra.some(
                            (checkedItem) =>
                              checkedItem.designation === item.designation &&
                              checkedItem.price === item.price &&
                              checkedItem.isChecked === true
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              ))}
            <div className="grid grid-cols-1 gap-6 text-sm xl:grid-cols-3 text-neutral-700 dark:text-neutral-300">
              {locationState?.extras &&
                reservation &&
                locationState?.extras?.map((item: any, index: number) => (
                  <div key={index} className="flex items-center space-x-3">
                    <i className="text-2xl las la-plus"></i>
                    <span>{item.designation}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (ownerInView && locationState?.userId) {
      dispatch(getOwnerById(locationState?.userId));
    }
  }, [ownerInView, id, dispatch]);

  const renderSection5 = () => {
    if (!ownerState) {
      // Loading skeleton
      return (
        <div ref={ownerRef} className="listingSection__wrap animate-pulse">
          <h2 className="text-2xl font-semibold">Proposé par</h2>
          <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

          <div className="flex items-center space-x-4">
            <div className="rounded-full h-14 w-14 bg-neutral-200 dark:bg-neutral-700" />
            <div className="space-y-2">
              <div className="w-24 h-4 rounded bg-neutral-200 dark:bg-neutral-700" />
              <div className="w-32 h-3 rounded bg-neutral-200 dark:bg-neutral-700" />
            </div>
          </div>

          <div className="space-y-2.5 mt-4">
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded bg-neutral-200 dark:bg-neutral-700" />
              <div className="w-40 h-4 rounded bg-neutral-200 dark:bg-neutral-700" />
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded bg-neutral-200 dark:bg-neutral-700" />
              <div className="w-32 h-4 rounded bg-neutral-200 dark:bg-neutral-700" />
            </div>
            <div className="w-48 h-10 rounded bg-neutral-200 dark:bg-neutral-700" />
          </div>
        </div>
      );
    }

    return (
      <div ref={ownerRef} className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Proposé par</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

        {/* host */}
        <div className="flex items-center space-x-4">
          <a href={`/owners/${ownerState?.id}`} aria-label={`Visit ${ownerState?.name}'s profile`}>
            <Avatar
              hasChecked
              hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
              sizeClass="h-14 w-14"
              radius="rounded-full"
              imgUrl={
                ownerState?.client_url ? `${process.env.REACT_APP_CLOUD_FRONT}${ownerState.client_url}` : undefined
              }
            />
          </a>
          <div>
            <span className="block font-medium">{ownerState?.name || "N/A"}</span>
            <div className="mt-1.5 flex items-center text-sm text-neutral-500 dark:text-neutral-400">
              <StartRating point={ownerState?.overallAverageLikes ?? 0} />
              <span className="mx-2">·</span>
              <span>{ownerState?.totalLocations ?? 0} Espaces</span>
            </div>
          </div>
        </div>

        {/* info */}
        <div className="block space-y-2.5 text-neutral-500 dark:text-neutral-400">
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span>
              Inscrit le{" "}
              {ownerState?.createdAt ? new Date(ownerState.createdAt).toLocaleDateString("fr-FR") : "N/A"}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
            <span>Temps de réponse - 100%</span>
          </div>

          {String(locationState?.Client?.id) !== String(authContext.user?.profil?.id) &&
            ownerState?.sendMessage && (
              <div className="mt-1">
                <ButtonPrimary type="button" onClick={handleConversation} aria-label="Envoyer un message à l'hôte">
                  Envoyer un message à l'hôte
                </ButtonPrimary>
              </div>
            )}
        </div>

        {/* divider */}
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

        {/* view profile */}
        <div className="w-1/2">
          {String(locationState?.Owner?.id) !== String(authContext.user?.profil?.id) && (
            <ButtonSecondary href={`/owners/${locationState?.Client?.id}`}>Voir le profil</ButtonSecondary>
          )}
        </div>
      </div>
    );
  };
  const PriceListSection: React.FC<any> = ({ availability = [], prices = [] }) => {
    const [expandedDay, setExpandedDay] = useState<string | null>(null);

    // Mapping des jours en français pour l'affichage
    const dayMapping: Record<string, string> = {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche",
      lundi: "Lundi",
      mardi: "Mardi",
      mercredi: "Mercredi",
      jeudi: "Jeudi",
      vendredi: "Vendredi",
      samedi: "Samedi",
      dimanche: "Dimanche",
    };

    // Mapping pour convertir anglais vers français pour la recherche de prix (avec majuscules)
    const dayMappingForPrices: Record<string, string> = {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche",
    };

    // Grouper les prix par jour
    const groupedPrices = prices.reduce((acc: Record<string, any[]>, price: any) => {
      if (!acc[price.day]) acc[price.day] = [];
      acc[price.day].push(price);
      return acc;
    }, {});

    // Organiser les prix par jour et par type
    const getDayPrices = (day: string) => {
      // Convertir le jour anglais en français pour chercher dans les prix (avec majuscule)
      const frenchDay = dayMappingForPrices[day.toLowerCase()] || day;
      const dayPrices = groupedPrices[frenchDay] || [];

      // Debug: vérifier la conversion

      const pricesByType = {
        heure: dayPrices.filter((p: any) => p.type === "heure"),
        "demi-journée": dayPrices.filter(
          (p: any) =>
            p.type === "demi-journée" || p.type === "demi-journée matin" || p.type === "demi-journée après-midi"
        ),
        "journée complète": dayPrices.filter((p: any) => p.type === "journée complète"),
        soirée: dayPrices.filter((p: any) => p.type === "soirée"),
      };

      // Debug: vérifier les types

      return pricesByType;
    };

    const getMinPrice = (prices: any[]) => {
      if (!prices || prices.length === 0) return null;
      return Math.min(...prices.map((p) => p.price));
    };

    return (
      <div className="listingSection__wrap">
        {/* Header */}
        <div>
          <h2 className="text-2xl font-semibold">Disponibilités et tarifs</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Découvrez nos tarifs par jour de la semaine
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 mb-8"></div>

        {/* Vue détaillée par jour */}
        <div className="space-y-4">
          {availability.map((day: string) => {
            const frenchDay = dayMapping[day.toLowerCase()] || day;
            const dayPrices = getDayPrices(day);
            const hasAnyPrice = Object.values(dayPrices).some((prices: any) => prices.length > 0);

            return (
              <div
                key={day}
                className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden"
              >
                <div
                  className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                  onClick={() => setExpandedDay(expandedDay === day ? null : day)}
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-eventToBee/10 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-eventToBee" fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 dark:text-white">{frenchDay}</h3>
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        {hasAnyPrice ? "Tarifs disponibles" : "Pas de tarifs configurés"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    {hasAnyPrice && (
                      <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                        À partir de{" "}
                        {Math.min(
                          ...Object.values(dayPrices)
                            .flat()
                            .map((p: any) => p.price)
                        )}
                        €
                      </span>
                    )}
                    <button className="text-eventToBee hover:text-eventToBee/80 transition-colors">
                      {expandedDay === day ? (
                        <svg className="w-5 h-5 transform rotate-180" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                {/* Grille des prix par type */}
                {expandedDay === day && (
                  <div className="border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                    <div className="p-6">
                      <div
                        className="grid grid-cols-1 md:grid-cols-2 gap-4"
                        style={{
                          gridTemplateColumns: (() => {
                            const availableTypes = [
                              dayPrices["heure"].length > 0,
                              dayPrices["demi-journée"].length > 0,
                              dayPrices["journée complète"].length > 0,
                              dayPrices["soirée"].length > 0,
                            ].filter(Boolean).length;

                            if (availableTypes === 1) return "repeat(1, 1fr)";
                            if (availableTypes === 2) return "repeat(2, 1fr)";
                            if (availableTypes === 3) return "repeat(auto-fit, minmax(250px, 1fr))";
                            return "repeat(auto-fit, minmax(200px, 1fr))";
                          })(),
                        }}
                      >
                        {/* Par heure */}
                        {dayPrices["heure"].length > 0 && (
                          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                            <div className="flex items-center space-x-2 mb-3">
                              <div className="w-3 h-3 rounded-full bg-gradient-to-r from-blue-500 to-blue-600"></div>
                              <h4 className="font-medium text-gray-900 dark:text-white">Par heure</h4>
                            </div>
                            <div className="space-y-2">
                              <div className="text-2xl font-bold text-eventToBee">
                                {getMinPrice(dayPrices["heure"])}€
                              </div>
                              <div className="text-xs text-gray-500 dark:text-gray-400">
                                {dayPrices["heure"].length} créneau{dayPrices["heure"].length > 1 ? "x" : ""}
                              </div>
                              {/* Détails de capacité et horaires */}
                              <div className="mt-2 space-y-1">
                                {dayPrices["heure"].map((price: any, index: number) => (
                                  <div
                                    key={index}
                                    className="text-xs bg-gray-100 dark:bg-gray-700 rounded px-2 py-1"
                                  >
                                    <div className="flex justify-between items-center">
                                      <span>
                                        {price.startHour} - {price.endHour}
                                      </span>
                                      <span className="font-medium">{price.price}€</span>
                                    </div>
                                    <div className="text-gray-500 dark:text-gray-400">
                                      👥 {price.min}-{price.max} personnes
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Demi-journée */}
                        {dayPrices["demi-journée"].length > 0 && (
                          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                            <div className="flex items-center space-x-2 mb-3">
                              <div className="w-3 h-3 rounded-full bg-gradient-to-r from-orange-500 to-orange-600"></div>
                              <h4 className="font-medium text-gray-900 dark:text-white">Demi-journée</h4>
                            </div>
                            <div className="space-y-2">
                              <div className="text-2xl font-bold text-eventToBee">
                                {getMinPrice(dayPrices["demi-journée"])}€
                              </div>
                              <div className="text-xs text-gray-500 dark:text-gray-400">
                                {dayPrices["demi-journée"].length} créneau
                                {dayPrices["demi-journée"].length > 1 ? "x" : ""}
                              </div>
                              {/* Détails de capacité et horaires pour demi-journée */}
                              <div className="mt-2 space-y-1">
                                {dayPrices["demi-journée"].map((price: any, index: number) => (
                                  <div
                                    key={index}
                                    className="text-xs bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded px-2 py-1"
                                  >
                                    <div className="flex justify-between items-center">
                                      <span>
                                        🕐 {price.startHour} - {price.endHour}
                                      </span>
                                      <span className="font-medium">{price.price}€</span>
                                    </div>
                                    <div className="text-gray-500 dark:text-gray-400">
                                      👥 {price.min}-{price.max} personnes
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Journée complète */}
                        {dayPrices["journée complète"].length > 0 && (
                          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                            <div className="flex items-center space-x-2 mb-3">
                              <div className="w-3 h-3 rounded-full bg-gradient-to-r from-green-500 to-green-600"></div>
                              <h4 className="font-medium text-gray-900 dark:text-white">Journée complète</h4>
                            </div>
                            <div className="space-y-2">
                              <div className="text-2xl font-bold text-eventToBee">
                                {getMinPrice(dayPrices["journée complète"])}€
                              </div>
                              <div className="text-xs text-gray-500 dark:text-gray-400">
                                {dayPrices["journée complète"].length} créneau
                                {dayPrices["journée complète"].length > 1 ? "x" : ""}
                              </div>
                              {/* Détails de capacité et horaires */}
                              <div className="mt-2 space-y-1">
                                {dayPrices["journée complète"].map((price: any, index: number) => (
                                  <div
                                    key={index}
                                    className="text-xs bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded px-2 py-1"
                                  >
                                    <div className="flex justify-between items-center">
                                      <span>
                                        🌞 {price.startHour} - {price.endHour}
                                      </span>
                                      <span className="font-medium">{price.price}€</span>
                                    </div>
                                    <div className="text-gray-500 dark:text-gray-400">
                                      👥 {price.min}-{price.max} personnes
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Soirée */}
                        {dayPrices["soirée"].length > 0 && (
                          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                            <div className="flex items-center space-x-2 mb-3">
                              <div className="w-3 h-3 rounded-full bg-gradient-to-r from-purple-500 to-purple-600"></div>
                              <h4 className="font-medium text-gray-900 dark:text-white">Soirée</h4>
                            </div>
                            <div className="space-y-2">
                              <div className="text-2xl font-bold text-eventToBee">
                                {getMinPrice(dayPrices["soirée"])}€
                              </div>
                              <div className="text-xs text-gray-500 dark:text-gray-400">
                                {dayPrices["soirée"].length} créneau{dayPrices["soirée"].length > 1 ? "x" : ""}
                              </div>
                              {/* Détails de capacité et horaires */}
                              <div className="mt-2 space-y-1">
                                {dayPrices["soirée"].map((price: any, index: number) => (
                                  <div
                                    key={index}
                                    className="text-xs bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded px-2 py-1"
                                  >
                                    <div className="flex justify-between items-center">
                                      <span>
                                        🌙 {price.startHour} - {price.endHour}
                                      </span>
                                      <span className="font-medium">{price.price}€</span>
                                    </div>
                                    <div className="text-gray-500 dark:text-gray-400">
                                      👥 {price.min}-{price.max} personnes
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Message informatif */}
        <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <div className="flex items-start space-x-3">
            <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
            <div>
              <p className="text-sm font-medium text-blue-900 dark:text-blue-200">💡 Bon à savoir</p>
              <p className="text-xs text-blue-800 dark:text-blue-300 mt-1">
                Les tarifs peuvent varier selon les week-ends, jours fériés et événements spéciaux. Contactez le
                propriétaire pour plus d'informations sur les tarifs personnalisés.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSection4 = () => {
    const availability = locationState?.availableDays || [];
    const prices = locationState?.prices || [];

    return <PriceListSection availability={availability} prices={prices} />;
  };

  // Section calendrier supprimée - le formulaire de réservation à droite suffit pour tous les types de locations

  // Calculateur de prix supprimé - le formulaire de réservation à droite gère déjà tous les calculs de prix

  useScrollToHash("#commentaires", "commentaire");

  useEffect(() => {
    if (commentsInView && id) {
      dispatch(fetchCommentById(id));
    }
  }, [commentsInView, id, dispatch]);

  const renderSection6 = () => {
    return (
      <div id="commentaire" ref={commentsRef} className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Avis ({commentStates?.totalComments})</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>
        {commentsInView ? (
          <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
            {commentStates?.comments
              .slice(0, showAllComments ? commentStates.comments.length : 5)
              .map((comment: any) => <CommentListing key={comment.id} data={comment} className="py-8" />)}
            {commentStates?.totalComments > 5 && (
              <ButtonSecondary onClick={() => setShowAllComments(!showAllComments)}>
                {showAllComments ? "Cacher les avis" : "Voir plus d'avis"}
              </ButtonSecondary>
            )}
          </div>
        ) : (
          <div>Loading comments...</div>
        )}
      </div>
    );
  };

  const renderSection7 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Localisation</h2>
        </div>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
        <div className="z-0 rounded-xl ring-1 aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-black/10">
          <div className="z-0 overflow-hidden rounded-xl">
            {lat && lng && (
              <iframe
                title="x"
                width="100%"
                height="100%"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={googleMapsURL}
              ></iframe>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div className="flex justify-between">
          <h2 className="text-2xl font-semibold">Informations suplémentaires</h2>
        </div>
        {/* CONTENT */}

        <span className="block text-neutral-500 dark:text-neutral-400">
          - Dêpot de garantie : {locationState?.guarantee} € <br />
        </span>
        <span className="block text-neutral-500 dark:text-neutral-400">
          - Frais de ménage{" "}
          {locationState?.cleaning_costs_events?.length >= 1 ? locationState.cleaning_costs_events.join(", ") : ""}
          {locationState?.cleaning_costs} € <br />
        </span>
      </div>
    );
  };

  const renderSection11 = () => {
    return (
      <div className=" listingSection__wrap">
        {/* HEADING */}
        <div className="flex justify-between ">
          <h2 className="text-2xl font-semibold">Politiques d'annulation</h2>
        </div>
        {/* CONTENT */}
        {locationState?.reservation_type === "Stricte" ? (
          <>
            <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
              <p>
                {" "}
                Stricte : Les clients peuvent annuler dans les 48 heures suivant la réservation pour un
                remboursement complet. Passé ce délai, aucune annulation n'est possible et aucun remboursement ne
                sera effectué.
              </p>

              <p>- Remboursement de 70 % de la valeur de la réservation en cas d'annulation </p>
            </span>
          </>
        ) : (
          <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
            <p>
              {" "}
              Flexible : Les clients peuvent annuler jusqu'à 5 jours avant la date d'arrivée prévue pour un
              remboursement de 70 % du montant total. Les annulations effectuées moins de 5 jours avant la date
              d'arrivée ne sont pas remboursables.
            </p>
          </span>
        )}
        <div></div>
      </div>
    );
  };

  const renderSidebar = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks

    return (
      <div id="renderSidebar" className="shadow-xl listingSectionSidebar__wrap">
        {/* PRICE */}

        <div
          className={`flex ${locationState?.availabilityList.length === 1 ? "justify-center" : "justify-between"}`}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="time selection"
            sx={(theme) => ({
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 500,
                color: theme.palette.mode === "dark" ? "#ffff" : "#6b7280",
                "&.Mui-selected": {
                  color: theme.palette.mode === "dark" ? "#ffffff" : "#2563eb",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#2563eb",
              },
            })}
          >
            {locationState?.availabilityList.map(({ label, value }: { label: any; value: any }) => (
              <Tab key={value} value={value} label={label} />
            ))}
          </Tabs>
        </div>
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            {price ? <>{price} €</> : <>{location_minPrice || 0} €</>}
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              {value ? <>/{value} </> : <>/{locationState && locationState.minPriceType} </>}
            </span>
          </span>
        </div>

        <div className="flex justify-center font-semibold text-center">
          <span>Quand souhaitez-vous reserver ?</span>
        </div>
        <form className="flex flex-col">
          <StayDatesRangeInput
            className="flex-1 z-[11] border-2 rounded-lg "
            availableDays={availableDays}
            onTotalDayChange={handleSelectedDayChange}
            fullyDays={fullyDaysState.map((day: { date: string }) => day.date)}
            unavailableDays={
              Array.isArray(unavailableState)
                ? unavailableState
                    .map((item: any) => {
                      // L'API peut retourner différents formats : chaîne directe ou objet avec différents champs
                      if (typeof item === "string") return item;
                      // Essayer différents champs possibles
                      return item.date || item.unavailableDate || item.startDay || item.endDay || item;
                    })
                    .filter(Boolean)
                : []
            }
            onClick={handleAvailibility}
            value={value}
          />
          <br />
          {Submit && value !== "journée complète" && (
            <div className="flex items-center justify-center">
              <BookingLoader />
            </div>
          )}
          {!Submit &&
            selectedDay &&
            locationState.cleaning_costs !== 0 &&
            locationState?.cleaning_costs_events.length !== 0 && (
              <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
                <FormItem label="Type d'événement" desc="">
                  <Select onChange={handleEventTypeChange} disabled={!selectedDay} value={selectedEvent || ""}>
                    <option value="" disabled>
                      Sélectionnez un événement
                    </option>
                    {Array.isArray(locationState?.events) &&
                      locationState?.events.map((item: any) => (
                        <option key={item} value={item}>
                          {mapEventToName(item)}
                        </option>
                      ))}
                  </Select>
                </FormItem>
              </motion.div>
            )}
          {!Submit && value === "heure" && selectedDay && (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              {/* === Champ “Heure d’entrée” === */}
              <FormItem label="Heure d'entrée" desc="">
                <Select
                  onChange={handleStartHourChange}
                  title={selectedDay ? "Sélectionnez une heure d'entrée" : "Veuillez ajouter le jour souhaité."}
                  disabled={!selectedDay || !availableHoursState.length}
                  value={selectedStartHour ?? ""}
                >
                  {!selectedDay && (
                    <option value="" disabled>
                      Veuillez d'abord sélectionner une date
                    </option>
                  )}
                  {selectedDay && !availableHoursState.length && (
                    <option value="" disabled>
                      Aucune heure disponible
                    </option>
                  )}
                  {selectedDay && availableHoursState.length > 0 && (
                    <option value="" disabled>
                      Sélectionnez une heure
                    </option>
                  )}

                  {/* On boucle sur availableHoursState pour n’afficher que les starts valides */}

                  {(() => {
                    if (!availableHoursState.length) return null;

                    // Extract the smallest and largest start hour from available slots
                    const startHour = Math.min(...availableHoursState.map((slot) => slot.start));
                    const lastStartHour = Math.max(...availableHoursState.map((slot) => slot.start));
                    const nbreHour = parseInt(locationState?.nbreHour);
                    const disableFromHour = lastStartHour + nbreHour;

                    // We'll go from the earliest to the last possible hour (inclusive)
                    const endHour = disableFromHour; // This ensures we also render disabled hours after the last slot
                    const totalHours = endHour - startHour + 1;

                    return Array.from({ length: totalHours }, (_, i) => i + startHour).map((hour) => {
                      const isAvailable = availableHoursState.some((slot) => slot.start === hour);
                      const shouldDisable = hour >= disableFromHour || !isAvailable;

                      return (
                        <option key={hour} value={hour} disabled={shouldDisable}>
                          {`${hour}:00`}
                        </option>
                      );
                    });
                  })()}
                </Select>
              </FormItem>
            </motion.div>
          )}
          {!Submit && (value === "demi-journée" || value === "soirée") && selectedDay && (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <FormItem label="Heure d'entrée" desc="">
                <Select
                  onChange={handleStartHourChange2}
                  title={selectedDay ? "Sélectionnez une heure d'entrée" : "Veuillez ajouter le jour souhaité."}
                  disabled={!selectedDay || !availableHoursState.length}
                  value={selectedHourRange}
                >
                  {!selectedDay && (
                    <option value="" disabled>
                      Veuillez d'abord sélectionner une date
                    </option>
                  )}
                  {selectedDay && !availableHoursState.length && (
                    <option value="" disabled>
                      Aucune plage horaire disponible
                    </option>
                  )}
                  {selectedDay && availableHoursState.length > 0 && (
                    <option value="" disabled>
                      Sélectionnez une plage horaire
                    </option>
                  )}
                  {selectedDay &&
                    availableHoursState.length > 0 &&
                    availableHoursState.map((hour: any, index: number) => (
                      <option
                        key={index}
                        value={
                          typeof hour === "string"
                            ? hour
                            : `${hour.start}-${hour.start + hour.durations[hour.durations.length - 1]}`
                        }
                      >
                        {typeof hour === "string"
                          ? hour
                          : `${hour.start}:00-${hour.start + hour.durations[hour.durations.length - 1]}:00`}
                      </option>
                    ))}
                </Select>
              </FormItem>
            </motion.div>
          )}
          {selectedDay && (value === "demi-journée" || value === "soirée") && selectedHourRange ? (
            <motion.div
              variants={formItemVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              className="mt-2"
            >
              <FormItem label="Visiteurs">
                <Select onChange={handleChangePrice} value={selectedPriceId}>
                  <option value="Nombre de visiteurs">Nombre de visiteurs</option>

                  {selectedStartHour !== null && selectedEndHour !== null ? (
                    (() => {
                      const formatTime = (time: string) => {
                        const hour = time.padStart(2, "0");
                        const minute = "00";
                        return `${hour}:${minute}`;
                      };

                      const dayMapping: { [key: string]: string } = {
                        Mon: "Lundi",
                        Tue: "Mardi",
                        Wed: "Mercredi",
                        Thu: "Jeudi",
                        Fri: "Vendredi",
                        Sat: "Samedi",
                        Sun: "Dimanche",
                      };

                      let selectedDayFrench = "Samedi";
                      if (selectedDay) {
                        const selectedDayEnglish = new Date(selectedDay).toString().split(" ")[0];
                        selectedDayFrench = dayMapping[selectedDayEnglish] || selectedDayFrench;
                      }

                      const filteredPrices = locationState?.prices?.filter((price: any) => {
                        const formattedStartHour = formatTime(price.startHour);
                        const formattedEndHour = formatTime(price.endHour);
                        const formattedSelectedStart = formatTime(selectedStartHour);
                        const formattedSelectedEnd = formatTime(selectedEndHour);

                        return (
                          formattedStartHour === formattedSelectedStart &&
                          formattedEndHour === formattedSelectedEnd &&
                          price.day === selectedDayFrench
                        );
                      });

                      return filteredPrices.length > 0 ? (
                        filteredPrices.map((price: any) => (
                          <option key={price.id} value={price.id}>
                            {price.min && price.max ? `${price.min}-${price.max}` : "N/A"}
                          </option>
                        ))
                      ) : (
                        <option disabled>Aucuns prix disponibles</option>
                      );
                    })()
                  ) : (
                    <option disabled>Veuillez d'abord sélectionner une plage horaire</option>
                  )}
                </Select>
              </FormItem>
            </motion.div>
          ) : null}
          {value === "journée complète" && selectedDay && (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <FormItem label="Visiteurs">
                <Select onChange={handleChangePrice} value={selectedPriceId}>
                  <option value="Nombre de visiteurs">Nombre de visiteurs</option>

                  {(() => {
                    const dayMapping: { [key: string]: string } = {
                      Mon: "Lundi",
                      Tue: "Mardi",
                      Wed: "Mercredi",
                      Thu: "Jeudi",
                      Fri: "Vendredi",
                      Sat: "Samedi",
                      Sun: "Dimanche",
                    };

                    let selectedDayFrench = "Samedi";
                    if (selectedDay) {
                      const selectedDayEnglish = new Date(selectedDay).toString().split(" ")[0];
                      selectedDayFrench = dayMapping[selectedDayEnglish] || selectedDayFrench;
                    }

                    const filteredPrices = locationState?.prices?.filter((price: any) => {
                      return price.type === value && price.day === selectedDayFrench;
                    });

                    return filteredPrices?.length > 0 ? (
                      filteredPrices.map((price: any) => (
                        <option key={price.id} value={price.id}>
                          {price.min && price.max ? `${price.min}-${price.max}` : "N/A"}
                        </option>
                      ))
                    ) : (
                      <option disabled>No prices available</option>
                    );
                  })()}
                </Select>
              </FormItem>
            </motion.div>
          )}
          {value === "heure" && selectedStartHour && (
            <motion.div
              variants={formItemVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              className="mt-2"
            >
              <FormItem label="Visiteurs">
                <Select onChange={handleChangePrice} value={selectedPriceId}>
                  <option value="" disabled>
                    Nombre de visiteurs
                  </option>

                  {selectedStartHour !== null ? (
                    (() => {
                      const dayMapping: { [key: string]: string } = {
                        Mon: "Lundi",
                        Tue: "Mardi",
                        Wed: "Mercredi",
                        Thu: "Jeudi",
                        Fri: "Vendredi",
                        Sat: "Samedi",
                        Sun: "Dimanche",
                      };

                      const selectedDayFrench = selectedDay
                        ? dayMapping[new Date(selectedDay).toString().split(" ")[0]] || "Samedi"
                        : "Samedi";

                      const filteredPrices = (locationState?.prices || []).filter((price: any) => {
                        return price.day === selectedDayFrench && price.type === "heure";
                      });

                      return filteredPrices.length > 0 ? (
                        filteredPrices.map((price: any) => (
                          <option key={price.id} value={price.id}>
                            {price.min && price.max ? `${price.min}-${price.max}` : "N/A"}
                          </option>
                        ))
                      ) : (
                        <option disabled>Aucun prix disponible</option>
                      );
                    })()
                  ) : (
                    <option disabled>Veuillez d'abord sélectionner une heure</option>
                  )}
                </Select>
              </FormItem>
            </motion.div>
          )}

          {value === "heure" && selectedDay && selectedStartHour && visitorRange ? (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <NcInputNumber
                className="w-full mt-6"
                defaultValue={periode}
                onChange={(value) => handleChangeDuration(value)}
                max={maxDuration}
                min={parseInt(locationState?.nbreHour || "1")}
                label="Durée"
              />
            </motion.div>
          ) : (value === "demi-journée" || value === "soirée") &&
            selectedHourRange &&
            visitorRange &&
            total > 0 ? (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <div className="flex justify-between mt-6">
                <div>{value === "demi-journée" ? "Demi-journée" : "Soirée"}</div>

                <div>
                  {" "}
                  {priceStartHour} - {priceEndHour}
                </div>
              </div>
            </motion.div>
          ) : priceId && value === "journée complète" && selectedDay ? (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <div className="flex justify-between mt-6">
                <div>Journée complète :</div>
                <div>
                  {" "}
                  {priceStartHour} - {priceEndHour}
                </div>
              </div>
            </motion.div>
          ) : (
            ""
          )}

          <div className="w-full mt-2 border-b border-neutral-200 dark:border-neutral-700"></div>
          <br />
          <div className="flex justify-center font-semibold text-center">
            <span>Détails</span>
          </div>
          {/* SUM */}

          <div className="flex flex-col space-y-4">
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>Sous-total </span>
              <span> {halfTotal} €</span>
            </div>

            {extraTotal && extraTotal !== 0 ? (
              <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                <span>Extra équipements</span>
                <span>{extraTotal} €</span>
              </div>
            ) : null}

            {selectedEvent && isCleaningCosts ? (
              <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                <span>Frais de ménage </span>
                <span>{locationState.cleaning_costs} €</span>
              </div>
            ) : null}

            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span className="flex items-center">
                Frais de service
                <div className="relative ml-2 group">
                  <svg
                    className="w-4 h-4 text-neutral-500 dark:text-neutral-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M12 3a9 9 0 100 18 9 9 0 000-18z"
                    ></path>
                  </svg>
                  <span className="absolute hidden px-2 py-1 mb-2 text-xs text-white -translate-x-1/2 rounded left-1/2 bottom-full group-hover:block bg-neutral-800 dark:bg-neutral-700 whitespace-nowrap">
                    TVA incluse
                  </span>
                </div>
              </span>
              <span> {services} €</span>
            </div>

            <div className="flex justify-between font-semibold">
              <span>Total</span>
              <span>{total} €</span>
            </div>
          </div>
          {/* SUBMIT */}
          <ButtonPrimary
            className="mt-5"
            type="button"
            loading={isLoadingSubmit}
            onClick={handleSubmit}
            disabled={!selectedDay || !price}
          >
            Demande de réservation
          </ButtonPrimary>
        </form>
      </div>
    );
  };

  const renderSidebar2 = () => {
    return (
      <motion.div
        id="renderSidebar"
        className="w-full p-6 bg-white shadow-lg dark:bg-neutral-800 rounded-2xl listingSectionSidebarInactive__wrap"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: EASING.easeOut }}
      >
        {/* PRICE */}
        <div className="">
          <div className="flex items-center ">
            <div>
              <p className="text-sm font-normal text-start text-neutral-500 dark:text-neutral-400">
                Intéressé par cet espace ? Contactez l’hôte pour
              </p>
              <p className="text-sm font-normal text-start text-neutral-500 dark:text-neutral-400">
                plus d’informations ou pour organiser une visite.
              </p>
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <form>
              <ButtonPrimary
                className="px-5 py-3 text-white transition-colors bg-blue-600 hover:bg-blue-700"
                type="button"
                loading={isLoadingSubmit}
                onClick={handleContact}
              >
                Contactez l'hôte
              </ButtonPrimary>
            </form>
          </div>
        </div>
      </motion.div>
    );
  };

  const renderSimilarLocations = ({
    locationState,
    relatedLocations,
    glideRef,
    renderPostRelated,
  }: {
    locationState: any;
    relatedLocations: any;
    glideRef: any;
    renderPostRelated: any;
  }) => {
    return (
      locationState &&
      relatedLocations?.length >= 4 && (
        <div className="relative py-16 mt-16 bg-neutral-100 dark:bg-neutral-800 lg:py-28 lg:mt-24">
          <div className="container glide" ref={glideRef}>
            <h2 className="text-3xl font-semibold text-center">Découvrez d'autres espaces similaires</h2>
            <div
              className="grid gap-6 mt-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-8 glide__track"
              data-glide-el="track"
            >
              <div
                className="glide__slides"
                style={{
                  transition: "height: 4755px !important",
                }}
              >
                {Array.isArray(relatedLocations) && relatedLocations.map(renderPostRelated)}
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  const renderPostRelated = (location: any) => {
    return (
      <div key={location.id} className="flex overflow-hidden aspect-w-13 aspect-h-1 rounded-3xl group">
        <a
          href={`/location/${location.id}`}
          aria-label={`Voir ${location?.title}`}
          className="absolute inset-0 z-10"
        >
          <span className="sr-only">Voir {location?.title}</span>
        </a>
        <NcImage
          className="object-cover w-full h-full transition-transform duration-300 transform group-hover:scale-105"
          src={process.env.REACT_APP_CLOUD_FRONT + location.image}
        />
        <div>
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black"></div>
        </div>
        <div className="flex flex-col justify-end items-start text-xs text-neutral-300 space-y-2.5 p-4">
          <h2 className="block max-w-full text-lg font-semibold text-white">
            <span className="line-clamp-2">{location?.title}</span>
          </h2>
        </div>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>{`Event To Bee - ${locationState?.title}`}</title>
        <meta
          name="description"
          content="Découvrez les détails du l'espace à louer pour votre évènement sur Event To Bee ."
        />
      </Helmet>

      {!loading ? (
        <DetailPagetLayout>
          <div className="mb-5 nc-ListingStayDetailPage">
            {/*  HEADER */}
            <header className="rounded-md sm:rounded-xl">
              <div className="relative grid grid-cols-3 gap-1 sm:grid-cols-4 sm:gap-2">
                <div
                  className="relative col-span-2 row-span-3 overflow-hidden rounded-md cursor-pointer sm:row-span-2 sm:rounded-xl"
                  onClick={handleOpenModalImageGallery}
                >
                  <img
                    className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-xl"
                    src={
                      process.env.REACT_APP_CLOUD_FRONT +
                      (locationState?.images?.[0] || "/images/placeholder-space.jpg")
                    }
                    alt=""
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                  />
                  <div className="absolute inset-0 transition-opacity opacity-0 bg-opacity-20 bg-neutral-900 hover:opacity-100">
                    <span className="sr-only">Voir la galerie d'images</span>
                  </div>
                </div>

                {locationState?.images?.slice(0, 4)?.map((item: string, index: number) => (
                  <div key={index} className={`relative rounded-md sm:rounded-xl overflow-hidden`}>
                    <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
                      <img
                        className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-xl"
                        src={process.env.REACT_APP_CLOUD_FRONT + item}
                        alt=""
                        sizes="400px"
                      />
                    </div>

                    <div
                      className="absolute inset-0 transition-opacity opacity-0 cursor-pointer bg-opacity-20 bg-neutral-900 hover:opacity-100"
                      onClick={handleOpenModalImageGallery}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => e.key === "Enter" && handleOpenModalImageGallery()}
                    >
                      <span className="sr-only">Voir cette image</span>
                    </div>
                  </div>
                ))}

                <button
                  className="absolute z-10 hidden px-4 py-2 bottom-3 left-3 rounded-xl md:flex md:items-center md:justify-center bg-neutral-100 text-neutral-500 hover:bg-neutral-200"
                  onClick={handleOpenModalImageGallery}
                >
                  <Squares2X2Icon className="w-5 h-5" />
                  <span className="ml-2 text-sm font-medium text-neutral-800">Afficher toutes les photos</span>
                </button>
              </div>
            </header>

            {/* MAIN */}
            <main className="relative z-10 flex flex-col mt-11 lg:flex-row">
              {/* CONTENT */}
              <div
                className={`space-y-8 w-full ${
                  String(locationState.Client.id) !== String(authContext.user?.profil?.id)
                    ? "lg:w-3/5 xl:w-2/3 lg:space-y-10 lg:pr-10"
                    : ""
                }`}
              >
                {renderSection1()}
                {renderSection2()}
                {locationState && locationState?.prices?.length > 0 && renderSection4()}
                {renderEventsSection()}
                {locationState.playground?.length > 0 && renderPlayGroundsSection()}

                {locationState?.equipments?.length > 0 && renderSection3()}
                {locationState?.extras?.length > 0 && renderSection10()}

                {locationState?.conditions?.length > 0 && renderSection9()}
                {renderSection5()}
                {renderSection6()}
                {renderSection7()}
                {renderSection8()}
                {renderSection11()}

                {showLoginModal && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black opacity-50"></div>

                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                      <div className="flex flex-col items-center p-6 bg-white rounded-lg dark:bg-neutral-900">
                        <div className="self-end mb-4">
                          <ButtonSecondary onClick={() => setShowLoginModal(false)}>X</ButtonSecondary>
                        </div>
                        <LoginModal LoginModal={(e) => setShowLoginModal(e)} />
                      </div>
                    </div>
                  </div>
                )}

                {showLastMinuteWarning && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center">
                    {/* Backdrop */}
                    <div className="absolute inset-0 bg-black opacity-50"></div>

                    {/* Dialog */}
                    <div className="relative z-10 max-w-md p-6 mx-auto space-y-4 text-yellow-800 bg-yellow-100 border border-yellow-400 rounded-md shadow-lg">
                      <p className="text-sm font-medium">
                        ⚠️ <strong>Attention : Demande de dernière minute</strong>
                      </p>
                      <p className="text-sm">
                        Vous êtes sur le point de réserver un espace pour un événement qui commence dans moins de
                        48 heures.
                        <br />
                        L’hôte dispose de 48 heures pour accepter ou refuser votre demande. Cependant, en raison de
                        la proximité de la date, il peut accepter à tout moment, y compris juste avant l’heure
                        prévue.
                        <br />
                        En validant votre demande, vous vous engagez à être prêt(e) à maintenir votre événement si
                        l’hôte accepte.
                      </p>

                      <div className="flex justify-end space-x-4">
                        <button
                          onClick={() => setShowLastMinuteWarning(false)}
                          className="px-4 py-2 text-sm text-gray-700 bg-white border rounded hover:bg-gray-100"
                        >
                          Annuler
                        </button>
                        <button
                          onClick={async () => {
                            setIsConfirmedLastMinute(true);
                            setShowLastMinuteWarning(false);
                            await handleSubmit(); // re-call with confirmation
                          }}
                          className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700"
                        >
                          Confirmer
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {contact && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black opacity-50"></div>

                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                      <div className="flex flex-col items-center p-6 bg-white rounded-lg dark:bg-neutral-900">
                        <ContactModal
                          open={contact}
                          handleClose={() => setContact(false)}
                          phone={authContext?.user?.profil?.phone}
                          alertText="Contactez l'hôte"
                          senderId={authContext?.user?.id}
                          receiverId={locationState?.Client?.userId}
                          showOwnerPhoneNumber={locationState?.Client?.User?.showPhoneNumber}
                          ownerPhoneNumber={locationState?.Client?.phone}
                          ownerEmail={locationState?.Client?.User?.email}
                          ownerFullName={
                            locationState?.Client?.companyName ||
                            locationState?.Client?.lastName + " " + locationState?.Client?.name
                          }
                          locationName={locationState?.title}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {showSocialMediaShare && <SocialMediaShare url={window.location.href} />}
              {!reservation && (
                <>
                  <div className="nc-ListingStayDetailPage">
                    {String(locationState.Client.id) === String(authContext.user?.profil?.id) ? (
                      <div className="fixed-sidebar"></div>
                    ) : String(locationState.Client.id) !== String(authContext.user?.profil?.id) &&
                      locationState?.Client?.User?.subscription_status === "inactive" ? (
                      <div className="fixed-sidebar">{renderSidebar()}</div>
                    ) : (
                      <div className="fixed-sidebar">{renderSidebar2()}</div>
                    )}
                    <br />
                  </div>
                </>
              )}
            </main>
          </div>

          <MobileFooterSticky price={price} minPrice={locationState ? Number(locationState?.minPrice) : 0} />
        </DetailPagetLayout>
      ) : (
        <>
          <div className="flex items-center justify-center h-screen">
            <DetailLoader icon={FaHome} />
          </div>
        </>
      )}
      {renderSimilarLocations({ locationState, relatedLocations, glideRef, renderPostRelated })}
    </>
  );
};

export default ListingStayDetailPage;
